<template>
  <v-dialog v-model="dialog" persistent scrollable="">
    <v-card>
      <v-card-title class="pa-5 bg-D5EEED">
        <v-btn :x-small="almost_mobile" icon disabled
          ><v-icon>mdi-clear</v-icon></v-btn
        >
        <span class="font-24" style="color: #4ba69d; font-weight: bold"
          >ข้อมูลพนักงาน</span
        >
        <v-spacer></v-spacer>
        <v-btn icon color="#4BA69D" @click="close()" small
          ><v-icon>mdi-close</v-icon></v-btn
        >
      </v-card-title>
      <v-card-text class="py-4">
        <v-row>
          <v-col cols="12" class="pa-0">
            <v-row class="bg-D5EEED">
              <v-col
                :style="
                  almost_mobile ? 'margin-left: 32px;' : 'margin-left: 64px;'
                "
              >
                <v-row>
                  <v-col cols="12" xs="6" sm="6" md="6" lg="6">
                    <span class="custom-text">รหัสพนักงาน : </span>
                    <span class="custom-text ml-2">
                      {{
                        selectPatient.employee_id
                          ? selectPatient.employee_id
                          : "-"
                      }}
                    </span>
                  </v-col>
                  <v-col cols="12" xs="6" sm="6" md="6" lg="6">
                    <span class="custom-text">แผนก : </span>
                    <span class="custom-text ml-2">
                      {{
                        selectPatient.department
                          ? selectPatient.department
                          : "-"
                      }}
                    </span>
                  </v-col>
                  <v-col cols="12" xs="6" sm="6" md="6" lg="6">
                    <span class="custom-text">ชื่อ-สกุล : </span>
                    <span class="custom-text ml-2">
                      {{ selectPatient.account_title_th || "" }}
                      {{ selectPatient.first_name_th || "" }}
                      {{ selectPatient.last_name_th || "" }}
                    </span>
                  </v-col>
                  <v-col cols="12" xs="6" sm="6" md="6" lg="6">
                    <span class="custom-text">หมายเลขโทรศัพท์ : </span>
                    <span class="custom-text ml-2">{{
                      showMobile(selectPatient.mobile) || "-"
                    }}</span>
                  </v-col>
                  <v-col cols="12" xs="6" sm="6" md="4" lg="4">
                    <span class="custom-text">เพศ : </span>
                    <span class="custom-text ml-2">{{
                      genderPerson(selectPatient.account_title_th)
                    }}</span>
                  </v-col>
                  <v-col cols="12" xs="6" sm="6" md="4" lg="4">
                    <span class="custom-text">วัน/เดือน/ปีเกิด : </span>
                    <span class="custom-text ml-2">{{
                      formatDate(selectPatient.birth_date) || "-"
                    }}</span>
                  </v-col>
                  <v-col cols="12" xs="6" sm="6" md="4" lg="4">
                    <span class="custom-text">อายุ : </span>
                    <span class="custom-text ml-2">{{
                      ageCalcilar(selectPatient.birth_date) || "-"
                    }}</span
                    ><span class="custom-text ml-2">ปี</span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" class="pa-0 pt-3">
                <v-tabs
                  class="px-0"
                  v-model="tab"
                  background-color="#00a99d"
                  centered
                  dark
                  icons-and-text
                  fixed-tabs
                >
                  <v-tabs-slider></v-tabs-slider>

                  <v-tab href="#tab-1">
                    <span class="font-18">ประวัติการรักษา</span>
                    <v-icon>mdi-heart</v-icon>
                  </v-tab>

                  <v-tab href="#tab-2">
                    <span class="font-18">ประวัติการโทร</span>
                    <v-icon>mdi-phone</v-icon>
                  </v-tab>

                  <v-tab href="#tab-4">
                    <span class="font-18">ประวัติการจ่ายยา</span>
                    <v-icon>mdi-pill</v-icon>
                  </v-tab>

                  <v-tab href="#tab-3">
                    <span class="font-18">ประวัติการเยี่ยมบ้าน</span>
                    <v-icon>mdi-home</v-icon>
                  </v-tab>
                </v-tabs>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-tabs-items v-model="tab">
              <v-tab-item value="tab-1">
                <v-row v-if="itemHistory.length !== 0" class="ma-5 mt-8">
                  <v-col cols="12" md="3" lg="3">
                    <v-row class="card_pr">
                      <v-col
                        cols="12"
                        class="bg-white pl-0 pr-0 mb-5"
                        style="
                          min-height: 45vh;
                          border-radius: 10px;
                          border: 1px #00a99d solid;
                        "
                      >
                        <v-row class="pa-1 ml-2">
                          <v-col
                            cols="12"
                            class="py-5 font-18 w-700 text-00A99D"
                          >
                            <span>ประวัติการรักษา</span>
                          </v-col>
                        </v-row>
                        <v-divider></v-divider>

                        <v-row class="pa-1 ml-2 mr-2">
                          <v-col align="center" cols="12" class="font-20 w-700">
                            <v-list dense>
                              <v-list-item-group
                                v-model="selectedItem"
                                @change="changeSelect"
                                mandatory
                              >
                                <v-list-item
                                  v-for="(item, index) in itemHistory"
                                  :key="index"
                                  class="my-1"
                                  style="
                                    border: 1px solid #e8e9e9;
                                    border-radius: 5px;
                                    background-color: #d5eeed;
                                  "
                                  active-class="set-active-color"
                                  :value="item._id"
                                >
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      <div class="d-flex flex-column">
                                        <v-row class="pa-0 ma-0">
                                          <v-col
                                            cols="12"
                                            class="pb-2 text-left px-0"
                                          >
                                            <span class="w-500 font-16 mt-2">
                                              {{ item.patient_name }}
                                            </span>
                                          </v-col>
                                          <v-col
                                            cols="12"
                                            class="pb-2 text-left px-0"
                                          >
                                            <span class="w-500 font-16 mt-2">
                                              {{ displayDate(item.createdAt) }}
                                            </span>
                                          </v-col>
                                        </v-row>
                                      </div>
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </v-list-item-group>
                            </v-list>
                          </v-col>
                          <v-col class="pa-0 ma-0">
                            <Pagination
                              v-if="total >= 5"
                              :totals="total"
                              :isPage="page"
                              :max="5"
                              @page="changePage"
                            />
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    cols="12"
                    md="9"
                    lg="9"
                    class="bg-white mb-5"
                    style="min-height: 45vh; border-radius: 10px"
                    v-if="showCurrent != null"
                  >
                    <v-row class="pr-0 pl-0">
                      <v-col
                        cols="12"
                        class="bg-white pl-0 pr-0"
                        style="min-height: 45vh; border-radius: 10px"
                      >
                        <v-row
                          class="ml-0 mr-0 mb-2"
                          style="border: 1px solid #00a99d; border-radius: 5px"
                        >
                          <v-col
                            cols="12"
                            sm="12"
                            md="6"
                            lg="6"
                            class="d-flex flex-column"
                          >
                            <span class="w-500 font-18 text-00A99D pb-5 pt-3"
                              >บันทึกทางการแพทย์</span
                            >
                            <v-divider></v-divider>

                            <div class="mt-3">
                              <span class="w-300 font-18 text-navy-50"
                                >อาการสำคัญ</span
                              >
                              <v-text-field
                                solo
                                dense
                                :readonly="true"
                                placeholder="กรอกอาการสำคัญ"
                                v-model="showCurrent.marjor_symptoms"
                                color="#00a99d"
                              />
                            </div>
                            <div>
                              <span class="w-300 font-18 text-navy-50"
                                >อาการปัจจุบัน
                              </span>
                              <v-text-field
                                solo
                                dense
                                :readonly="true"
                                placeholder="กรอกอาการปัจจุบัน"
                                v-model="showCurrent.current_symptoms"
                                color="#00a99d"
                              />
                            </div>
                            <div>
                              <span class="w-300 font-18 text-navy-50"
                                >โรคประจำตัว</span
                              >
                              <v-text-field
                                solo
                                :readonly="true"
                                dense
                                placeholder="กรอกโรคประจำตัว"
                                v-model="showCurrent.congenital_disease"
                                color="#00a99d"
                              />
                            </div>
                            <div>
                              <span class="w-300 font-18 text-navy-50"
                                >บันทึกทางการแพทย์</span
                              >
                              <v-text-field
                                solo
                                dense
                                :readonly="true"
                                placeholder="กรอกบันทึกทางการแพทย์"
                                v-model="showCurrent.medical_record"
                                hide-details
                                color="#00a99d"
                              />
                            </div>
                            <div
                              v-if="showCurrent.screenShot"
                              class="d-flex flex-column pt-6"
                            >
                              <span class="w-300 font-18 text-navy-50">
                                รูปภาพ
                              </span>
                              <div class="pt-2">
                                <img
                                  :src="showCurrent.screenShot"
                                  alt="Video Screenshot"
                                  class="screenshot-img"
                                />
                              </div>
                            </div>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="12"
                            md="6"
                            lg="6"
                            class="pr-0 pb-0"
                            style="border-left: 1px solid #00a99d"
                          >
                            <v-row
                              class="pa-2 mx-0"
                              style="height: 100%"
                              v-if="
                                selectedItem !== '' &&
                                selectedItem !== undefined
                              "
                            >
                              <div
                                v-for="(drug, index) in itemDrug"
                                :key="`${drug.id}-drug`"
                              >
                                <v-col
                                  cols="12"
                                  class="font-20 w-700 pb-2 pr-0 pl-0"
                                  v-if="showData(itemDrug, index)"
                                >
                                  <div v-if="drug.drug.length !== 0">
                                    <v-row class="ma-0 pa-0">
                                      <v-col
                                        class="d-flex pa-1 align-center"
                                        style="border-bottom: 1px #313b41 solid"
                                      >
                                        <span class="w-300 font-18 text-00A99D"
                                          >สั่งยา</span
                                        >
                                      </v-col>
                                    </v-row>
                                    <v-row
                                      class="ma-0 pa-0 mb-3"
                                      style="border-bottom: 1px #313b41 solid"
                                      v-if="drug.drug.length !== 0"
                                    >
                                      <v-col class="pa-1" cols="1">
                                        <span class="w-300 font-18 text-00A99D"
                                          >#</span
                                        >
                                      </v-col>
                                      <v-col class="pa-1" cols="4">
                                        <span class="w-300 font-18 text-00A99D"
                                          >รายการยา</span
                                        >
                                      </v-col>
                                      <v-col
                                        class="pa-1"
                                        cols="2"
                                        align="center"
                                      >
                                        <span class="w-300 font-18 text-00A99D"
                                          >จำนวน</span
                                        >
                                      </v-col>
                                      <v-col
                                        class="pa-1"
                                        cols="2"
                                        align="center"
                                      >
                                        <span class="w-300 font-18 text-00A99D"
                                          >ราคา</span
                                        >
                                      </v-col>
                                      <v-col
                                        class="pa-1"
                                        cols="2"
                                        align="center"
                                      >
                                        <span class="w-300 font-18 text-00A99D"
                                          >ราคารวม
                                        </span>
                                      </v-col>
                                      <v-col
                                        class="pa-1"
                                        cols="1"
                                        align="center"
                                      >
                                        <span class="w-300 font-18 text-313B41">
                                        </span>
                                      </v-col>
                                    </v-row>

                                    <v-row
                                      class="ma-0 pa-0"
                                      v-for="(item, index) in drug.drug"
                                      :key="index"
                                    >
                                      <v-col
                                        class="pa-1"
                                        cols="1"
                                        align-self="center"
                                      >
                                        <span
                                          class="w-300 font-18 text-313B41"
                                          >{{ index + 1 }}</span
                                        >
                                      </v-col>
                                      <v-col class="pa-1" cols="4">
                                        <span class="w-300 font-18 text-313B41">
                                          <v-text-field
                                            class="text-field"
                                            :value="item.name_drug"
                                            outlined
                                            dense
                                            small
                                            hide-details
                                            color="#00a99d"
                                          ></v-text-field>
                                        </span>
                                      </v-col>
                                      <v-col
                                        class="pa-1"
                                        cols="2"
                                        align="center"
                                      >
                                        <span class="w-300 font-18 text-313B41">
                                          <v-text-field
                                            class="text-field"
                                            type="number"
                                            v-model="item.count"
                                            outlined
                                            dense
                                            small
                                            hide-details
                                            :min="0"
                                            color="#00a99d"
                                          ></v-text-field>
                                        </span>
                                      </v-col>
                                      <v-col
                                        class="pa-1 text-center"
                                        cols="2"
                                        align="center"
                                      >
                                        <span class="w-300 font-18 text-313B41">
                                          <v-text-field
                                            class="text-field"
                                            :value="item.price"
                                            outlined
                                            dense
                                            small
                                            readonly
                                            hide-details
                                            color="#00a99d"
                                          ></v-text-field>
                                        </span>
                                      </v-col>
                                      <v-col
                                        class="pa-1"
                                        cols="2"
                                        align="center"
                                        text-align="center"
                                      >
                                        <span class="w-300 font-18 text-313B41">
                                          <v-text-field
                                            class="text-field"
                                            :value="item.total"
                                            outlined
                                            dense
                                            small
                                            readonly
                                            hide-details
                                            color="#00a99d"
                                          ></v-text-field>
                                        </span>
                                      </v-col>
                                      <v-col
                                        class="pa-1"
                                        cols="1"
                                        align="center"
                                        text-align="center"
                                      >
                                      </v-col>

                                      <v-col
                                        class="pa-1"
                                        cols="1"
                                        align-self="center"
                                      ></v-col>
                                      <v-col
                                        class="pa-1"
                                        cols="10"
                                        align-self="center"
                                      >
                                        <v-row class="usageAndAdvice">
                                          <v-col
                                            class="pa-1"
                                            cols="12"
                                            align-self="center"
                                            style="
                                              white-space: wrap;
                                              text-overflow: ellipsis;
                                            "
                                          >
                                            <span
                                              class="w-700 font-14 text-313B41"
                                            >
                                              ข้อมูลการใช้ยา :
                                            </span>
                                            <span
                                              class="w-300 font-14 text-313B41"
                                            >
                                              {{ item.usage || "-" }}
                                            </span>
                                          </v-col>
                                          <v-col
                                            class="pa-1"
                                            cols="12"
                                            align-self="center"
                                            style="text-align: center"
                                            v-if="item.advice"
                                          >
                                            <span
                                              class="w-700 font-12 text-EB5757"
                                            >
                                              ***
                                              {{ item.advice }}
                                              ***
                                            </span>
                                          </v-col>
                                        </v-row>
                                      </v-col>
                                    </v-row>
                                    <v-col
                                      cols="12"
                                      class="d-flex justify-center"
                                    >
                                      <span
                                        >สรุปยอดรายการยา
                                        {{ sum(index) }} บาท</span
                                      >
                                    </v-col>
                                  </div>
                                </v-col>
                              </div>

                              <v-row
                                class="pa-0 ma-0"
                                v-if="
                                  showCurrent == null ||
                                  showCurrent.drug_list.length == 0
                                "
                              >
                                <v-col
                                  cols="12"
                                  class="noitems d-flex justify-center align-center text-center"
                                >
                                  <span class="font-18 w-700 text-00A99D"
                                    >ไม่มีรายการยา</span
                                  >
                                </v-col>
                              </v-row>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row v-else class="ma-5 mt-8">
                  <v-col
                    cols="12"
                    class="bg-white pl-0 pr-0 mb-5"
                    style="height: 40vh"
                    align="center"
                  >
                    <span class="font-18 w-700 text-00A99D"
                      >ไม่พบประวัติการรักษา</span
                    >
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item value="tab-2">
                <v-row v-if="itemHistoryCalling.length !== 0" class="ma-5">
                  <v-col cols="12" class="py-0">
                    <v-data-table
                      class="table-viewdoc"
                      :headers="headers"
                      :items="itemHistoryCalling"
                      hide-default-footer
                    >
                      <template v-slot:item.no="{ item }">
                        <span>{{
                          item.type == "WTW"
                            ? "Teleconsult"
                            : item.type == "Telemed"
                            ? "Telemedicine"
                            : item.type == "EMR"
                            ? "Emergency call"
                            : "-"
                        }}</span>
                      </template>
                      <template v-slot:item.name="{ item }">
                        <span>{{ displayCalling(item) }}</span>
                      </template>

                      <template v-slot:item.patient="{ item }">
                        <span>
                          {{ displayName(item) }}
                        </span>
                      </template>

                      <template v-slot:item.createdAt="{ item }">
                        <div class="d-flex flex-column text-left py-3">
                          <span>{{ displayDate(item.createdAt, "time") }}</span>
                        </div>
                      </template>
                    </v-data-table>
                  </v-col>

                  <v-spacer></v-spacer>
                  <v-col cols="12" class="py-0">
                    <Pagination
                      v-if="totalCalling >= 5"
                      :totals="totalCalling"
                      :isPage="pageCalling"
                      :max="5"
                      @page="changePageCalling"
                    />
                  </v-col>
                </v-row>
                <v-row v-else class="ma-5 mt-8">
                  <v-col
                    cols="12"
                    class="bg-white pl-0 pr-0 mb-5"
                    style="height: 40vh"
                    align="center"
                  >
                    <span class="font-18 w-700 text-00A99D"
                      >ไม่พบประวัติการโทร</span
                    >
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item value="tab-3">
                <!-- ค้นหา -->
                <v-col cols="12" class="pt-4">
                  <v-row class="my-2 mx-1">
                    <v-spacer></v-spacer>
                    <v-col
                      cols="12"
                      md="3"
                      lg="3"
                      xl="3"
                      class="pa-2 card-search-start"
                    >
                      <v-select
                        hide-details
                        solo
                        dense
                        :menu-props="{ bottom: true, offsetY: true }"
                        v-model="select_status"
                        :items="status_list"
                        item-text="text"
                        item-value="value"
                        @input="selectStatus"
                        item-color="teal darken-2"
                        color="#00A99D"
                        class="card-small set-card"
                      >
                        <template v-slot:item="{ item }">
                          <span class="font-14">{{ item.text }}</span>
                        </template>
                        <template v-slot:selection="{ item }">
                          <span class="font-14">{{ item.text }}</span>
                        </template>
                      </v-select>
                    </v-col>
                    <v-col
                      cols="12"
                      md="3"
                      lg="3"
                      xl="3"
                      class="pa-2 card-search-end"
                    >
                      <v-menu
                        v-model="day_menu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="350px"
                        min-width="auto"
                        bottom
                        left
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            solo
                            dense
                            placeholder="วัน/เดือน/ปี ที่นัดหมาย"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            hide-details
                            color="#00A99D"
                            v-model="dateText"
                            class="card-small set-card"
                          >
                            <template slot="append">
                              <v-icon color="#00A99D"
                                >mdi-calendar-multiselect</v-icon
                              >
                            </template>
                          </v-text-field>
                        </template>
                        <v-date-picker
                          v-model="select_date"
                          no-title
                          scrollable
                          range
                          locale="th"
                          color="#00A99D"
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="#00A99D" @click="selectDate()">
                            ตกลง
                          </v-btn>
                          <v-btn text color="#00A99D" @click="clearDate()">
                            ล้างค่า/clear
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-col>

                <v-row v-if="itemHistoryHomeVisit.length !== 0" class="ma-0">
                  <v-col cols="12" class="py-0">
                    <v-data-table
                      :headers="headersHomeVisit"
                      :items="itemHistoryHomeVisit"
                      hide-default-footer
                      :loading="loadingTable"
                      loading-text="กำลังโหลดข้อมูล"
                      disable-sort
                      :expanded.sync="expanded"
                      item-key="_id"
                      show-expand
                      single-expand
                    >
                      <template v-slot:no-data>
                        <span class="font-16">ไม่มีข้อมูล</span>
                      </template>

                      <template v-slot:progress>
                        <v-progress-linear
                          indeterminate
                          color="#00A99D"
                          class="px-0"
                        ></v-progress-linear>
                      </template>

                      <!-- -------------------------------------- ครั้งที่ ----------------------------------- -->
                      <template v-slot:item.appointment_no="{ item }">
                        <div class="d-flex flex-column">
                          <span
                            v-if="
                              'appointment_no' in item &&
                              item.appointment_no !== '' &&
                              item.appointment_no !== null &&
                              item.appointment_no !== undefined
                            "
                            class="font-14 text-navy-50"
                            >{{ item.appointment_no || "-" }}</span
                          >
                          <span v-else class="font-14 text-navy-50">-</span>
                        </div>
                      </template>

                      <!-- --------------------------------------ชื่อผู้ใช้บริการ----------------------------------- -->
                      <template v-slot:item.name="{ item }">
                        <div class="d-flex flex-column py-2">
                          <span class="font-14 text-00A99D"
                            >HN :
                            <span
                              v-if="
                                'HN' in item &&
                                item.HN !== '' &&
                                item.HN !== null &&
                                item.HN !== undefined
                              "
                              class="font-14 text-navy-50"
                              >{{ item.HN || "-" }}</span
                            >
                            <span v-else class="font-14 text-navy-50"
                              >-</span
                            ></span
                          >
                          <span class="font-14 text-00A99D"
                            >ชื่อ :
                            <span
                              v-if="
                                'fullname' in item &&
                                item.fullname !== '' &&
                                item.fullname !== null &&
                                item.fullname !== undefined
                              "
                              class="font-14 text-navy-50"
                              >{{ item.fullname || "-" }}</span
                            >
                            <span v-else class="font-14 text-navy-50"
                              >-</span
                            ></span
                          >
                          <span class="font-14 text-00A99D"
                            >เบอร์โทร :
                            <span
                              v-if="
                                'mobile' in item &&
                                item.mobile !== '' &&
                                item.mobile !== null &&
                                item.mobile !== undefined
                              "
                              class="font-14 text-navy-50"
                              >{{ showMobile(item.mobile) }}</span
                            >
                            <span v-else class="font-14 text-navy-50"
                              >-</span
                            ></span
                          >
                        </div>
                      </template>

                      <!-- --------------------------------------วันที่นัดหมาย----------------------------------- -->
                      <template v-slot:item.slot_date="{ item }">
                        <div
                          v-if="
                            'slot_date' in item &&
                            item.slot_date !== '' &&
                            item.slot_date !== null &&
                            item.slot_date !== undefined
                          "
                          class="d-flex flex-column"
                        >
                          <span class="font-14 text-00A99D">{{
                            formatDate(item.slot_date) || "-"
                          }}</span>
                          <span
                            v-if="item.start_time && item.end_time"
                            class="font-14 text-navy-50"
                            >{{
                              item.start_time + "-" + item.end_time
                            }}
                            น.</span
                          >
                          <span v-else class="font-16 text-navy-50">-</span>
                        </div>
                        <div
                          class="d-flex flex-column font-14 text-00A99D"
                          v-else
                        >
                          -
                        </div>
                      </template>

                      <!-- --------------------------------------doctor_name ทีมแพทย์----------------------------------- -->
                      <template v-slot:item.doctor_name="{ item }">
                        <span
                          v-if="
                            'doctor_name' in item &&
                            item.doctor_name !== '' &&
                            item.doctor_name !== null &&
                            item.doctor_name !== undefined
                          "
                          class="font-14 text-navy-50"
                          >{{ item.doctor_name }}</span
                        >
                        <span v-else class="font-14 text-navy-50">-</span>
                      </template>

                      <!-- --------------------------------------สถานะ----------------------------------- -->
                      <template v-slot:item.status="{ item }">
                        <v-row
                          v-if="
                            'status' in item &&
                            item.status !== '' &&
                            item.status == '1'
                          "
                        >
                          <v-col cols="12" align-self="center">
                            <span class="pl-1 font-14 text-296ED5"
                              >รอเยียมบ้าน</span
                            >
                          </v-col>
                        </v-row>
                        <v-row
                          v-else-if="
                            'status' in item &&
                            item.status !== '' &&
                            item.status == '2'
                          "
                        >
                          <v-col cols="12" align-self="center">
                            <span class="pl-1 font-14 text-FFB649"
                              >กำลังดำเนินการ</span
                            >
                          </v-col>
                        </v-row>
                        <v-row
                          v-else-if="
                            'status' in item &&
                            item.status !== '' &&
                            item.status == '3'
                          "
                        >
                          <v-col cols="12" align-self="center">
                            <span class="pl-1 font-14 text-1CCE39"
                              >เสร็จสิ้น</span
                            >
                          </v-col>
                        </v-row>
                        <v-row
                          v-else-if="
                            'status' in item &&
                            item.status !== '' &&
                            item.status == '4'
                          "
                        >
                          <v-col cols="12" align-self="center">
                            <span class="pl-1 font-14 text-FF6270">ยกเลิก</span>
                          </v-col>
                        </v-row>
                        <span v-else class="font-16 text-navy-50">-</span>
                      </template>

                      <!-- data-table-expand -->
                      <template
                        v-slot:item.data-table-expand="{
                          item,
                          expand,
                          isExpanded,
                        }"
                      >
                        <td>
                          <v-btn
                            fab
                            text
                            small
                            color="#FFFFFF"
                            @click="
                              expand(!isExpanded),
                                setLoadingPDF(item.form_list.length)
                            "
                            v-if="
                              item.status != '1' &&
                              'form_list' in item &&
                              item.form_list.length > 0
                            "
                          >
                            <v-icon
                              :style="
                                isExpanded ? 'transform: rotate(-180deg);' : ''
                              "
                              color="#00a99d"
                              >mdi-chevron-down</v-icon
                            >
                          </v-btn>
                        </td>
                      </template>

                      <!-- expanded-item -->
                      <template v-slot:expanded-item="{ headers, item }">
                        <td
                          :colspan="headers.length"
                          class="py-1"
                          style="background-color: white"
                        >
                          <v-row
                            v-for="(value, index) in item.form_list"
                            :key="index"
                            class="py-2"
                          >
                            <v-col cols="12">
                              <v-card
                                flat
                                color="#ebf7f7"
                                class="card-form_list"
                              >
                                <v-row>
                                  <v-col
                                    cols="3"
                                    xl="1"
                                    lg="1"
                                    md="1"
                                    sm="1"
                                    class="pr-0"
                                    align="end"
                                  >
                                    <Doc
                                      :class="
                                        display_vuetify == 'xs'
                                          ? 'mx-1 icon-image'
                                          : 'mx-1 icon-image'
                                      "
                                    />
                                  </v-col>
                                  <v-col
                                    cols="8"
                                    xl="6"
                                    lg="6"
                                    md="6"
                                    sm="6"
                                    class="pl-0"
                                    align-self="center"
                                  >
                                    <span
                                      :class="
                                        display_vuetify == 'xs'
                                          ? 'font-12 w-500 text-navy-50'
                                          : 'font-14 w-500 text-navy-50'
                                      "
                                      >{{ value.form_name }}</span
                                    >
                                  </v-col>
                                  <v-col
                                    cols="12"
                                    xl="2"
                                    lg="2"
                                    md="2"
                                    sm="2"
                                    align-self="center"
                                    align="center"
                                  >
                                    <v-btn
                                      v-if="
                                        'status' in value &&
                                        value.status !== '' &&
                                        value.status == 'success'
                                      "
                                      rounded
                                      depressed
                                      color="#2cc63b3b"
                                      small
                                      style="cursor: inherit"
                                    >
                                      <v-row>
                                        <v-col cols="12" align-self="center">
                                          <v-icon color="#2CC63B" size="12"
                                            >mdi-circle</v-icon
                                          ><span
                                            class="pl-1 font-12 text-2CC63B"
                                            >เสร็จสิ้น</span
                                          >
                                        </v-col>
                                      </v-row>
                                    </v-btn>
                                    <v-btn
                                      v-else-if="
                                        'status' in value &&
                                        value.status !== '' &&
                                        value.status == 'wait'
                                      "
                                      rounded
                                      depressed
                                      color="#f1ce9785"
                                      small
                                      style="cursor: inherit"
                                    >
                                      <v-row>
                                        <v-col cols="12" align-self="center">
                                          <v-icon color="#fe9c05" size="12"
                                            >mdi-circle</v-icon
                                          ><span
                                            class="pl-1 font-12 text-fe9c05"
                                            >กำลังดำเนินการ</span
                                          >
                                        </v-col>
                                      </v-row>
                                    </v-btn>
                                    <v-btn
                                      v-else-if="
                                        'status' in value &&
                                        value.status !== '' &&
                                        value.status == 'cancel'
                                      "
                                      rounded
                                      depressed
                                      color="#f38c8cad"
                                      small
                                      style="cursor: inherit"
                                    >
                                      <v-row>
                                        <v-col cols="12" align-self="center">
                                          <v-icon color="#f3051a" size="12"
                                            >mdi-circle</v-icon
                                          ><span
                                            class="pl-1 font-12 text-f3051a"
                                            >ยกเลิก</span
                                          >
                                        </v-col>
                                      </v-row>
                                    </v-btn>
                                    <span v-else class="font-16 text-navy-50"
                                      >-
                                    </span>
                                  </v-col>
                                  <v-col
                                    cols="12"
                                    xl="3"
                                    lg="3"
                                    md="3"
                                    sm="3"
                                    align-self="center"
                                    style="justify-content: center"
                                    class="d-flex d-flex-row"
                                  >
                                    <div
                                      v-if="
                                        'status' in value &&
                                        value.status !== '' &&
                                        (value.status == 'wait' ||
                                          value.status == 'success')
                                      "
                                    >
                                      <v-tooltip bottom>
                                        <template
                                          v-slot:activator="{ on, attrs }"
                                        >
                                          <v-btn
                                            large
                                            icon
                                            v-bind="attrs"
                                            v-on="on"
                                            class="py-4 px-2 mx-1 image-border"
                                            color="#00A99D"
                                            @click="
                                              check_form(item, value, 'detail')
                                            "
                                          >
                                            <v-icon>mdi-eye</v-icon>
                                          </v-btn>
                                        </template>
                                        <span>ดูรายละเอียด</span>
                                      </v-tooltip>
                                    </div>
                                    <div
                                      v-if="
                                        'status' in value &&
                                        value.status !== '' &&
                                        value.status == 'success'
                                      "
                                    >
                                      <v-tooltip bottom>
                                        <template
                                          v-slot:activator="{ on, attrs }"
                                        >
                                          <v-btn
                                            large
                                            icon
                                            v-bind="attrs"
                                            v-on="on"
                                            class="py-4 px-2 mx-1 image-border"
                                            color="#00a99d"
                                            :loading="loading_PDF[index]"
                                            @click="PDF_Dialog(value, index)"
                                          >
                                            <v-icon>mdi-file-download</v-icon>
                                          </v-btn>
                                        </template>
                                        <span>ดาวน์โหลด PDF</span>
                                      </v-tooltip>
                                    </div>
                                    <div
                                      v-if="
                                        'status' in value &&
                                        value.status !== '' &&
                                        value.status == 'cancel'
                                      "
                                    >
                                      <v-tooltip bottom>
                                        <template
                                          v-slot:activator="{ on, attrs }"
                                        >
                                          <v-btn
                                            large
                                            icon
                                            v-bind="attrs"
                                            v-on="on"
                                            class="py-4 px-2 mx-1 image-border"
                                            color="#00a99d"
                                            @click="
                                              cancelForm(item, value, 'see')
                                            "
                                          >
                                            <v-icon
                                              >mdi-file-cancel-outline</v-icon
                                            >
                                          </v-btn>
                                        </template>
                                        <span>ดูหมายเหตุการยกเลิก</span>
                                      </v-tooltip>
                                    </div>
                                  </v-col>
                                </v-row>
                              </v-card>
                            </v-col>
                          </v-row>
                        </td>
                      </template>
                    </v-data-table>
                  </v-col>

                  <v-spacer></v-spacer>
                  <v-col cols="12" class="py-0">
                    <Pagination
                      v-if="totalHomeVisit > limitHomeVisit"
                      :totals="totalHomeVisit"
                      :isPage="pageHomeVisit"
                      :max="limitHomeVisit"
                      @page="changePageHomeVisit"
                    />
                  </v-col>
                </v-row>
                <v-row v-else class="ma-5 mt-8">
                  <v-col
                    cols="12"
                    class="bg-white pl-0 pr-0 mb-5"
                    style="height: 40vh"
                    align="center"
                  >
                    <span class="font-18 w-700 text-00A99D"
                      >ไม่พบประวัติการเยี่ยมบ้าน</span
                    >
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item value="tab-4">
                <v-row v-if="itemPrescription.length !== 0" class="ma-5 mt-8">
                  <v-col cols="12" md="3" lg="3">
                    <v-row class="card_pr">
                      <v-col
                        cols="12"
                        class="bg-white pl-0 pr-0 mb-5"
                        style="
                          min-height: 45vh;
                          border-radius: 10px;
                          border: 1px #00a99d solid;
                        "
                      >
                        <v-row class="pa-1 ml-2">
                          <v-col
                            cols="12"
                            class="py-5 font-18 w-700 text-00A99D"
                          >
                            <span>ประวัติการจ่ายยา</span>
                          </v-col>
                        </v-row>
                        <v-divider></v-divider>

                        <v-row class="pa-1 ml-2 mr-2">
                          <v-col align="center" cols="12" class="font-20 w-700">
                            <v-list dense>
                              <v-list-item-group
                                v-model="selectedItem2"
                                @change="changeSelect2"
                                mandatory
                              >
                                <v-list-item
                                  v-for="(item, index) in itemPrescription"
                                  :key="index"
                                  class="my-1"
                                  style="
                                    border: 1px solid #e8e9e9;
                                    border-radius: 5px;
                                    background-color: #d5eeed;
                                  "
                                  active-class="set-active-color"
                                  :value="item._id"
                                >
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      <div class="d-flex flex-column" style="">
                                        <v-row class="pa-0 ma-0">
                                          <v-col
                                            cols="12"
                                            class="pb-2 text-left px-0"
                                          >
                                            <span class="w-500 font-16 mt-2">
                                              {{ item.patient_name }}
                                            </span>
                                          </v-col>
                                          <v-col
                                            cols="12"
                                            class="pb-2 text-left px-0"
                                          >
                                            <span class="w-500 font-16 mt-2">
                                              {{ displayDate(item.updatedAt) }}
                                            </span>
                                          </v-col>
                                        </v-row>
                                      </div>
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </v-list-item-group>
                            </v-list>
                          </v-col>
                          <v-col class="pa-0 ma-0">
                            <Pagination
                              :totals="totalPrescpt"
                              :isPage="pagePrescpt"
                              @page="changePagePrescpt"
                            />
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    cols="12"
                    md="9"
                    lg="9"
                    class="bg-white mb-5"
                    style="min-height: 45vh; border-radius: 10px"
                    v-if="showCurrent2 != null"
                  >
                    <v-row class="pr-0 pl-0">
                      <v-col
                        cols="12"
                        class="bg-white pl-0 pr-0"
                        style="min-height: 45vh; border-radius: 10px"
                      >
                        <v-row
                          class="ml-0 mr-0 mb-2"
                          style="border: 1px solid #00a99d; border-radius: 5px"
                        >
                          <v-col cols="12" lg="12">
                            <v-row
                              class="pa-2 mx-0"
                              style="height: 100%"
                              v-if="
                                selectedItem2 !== '' &&
                                selectedItem2 !== undefined
                              "
                            >
                              <div
                                v-for="(drug, index) in itemDrug2"
                                :key="`${drug.id}-drug`"
                              >
                                <v-col
                                  cols="12"
                                  class="font-20 w-700 pb-2 pr-0 pl-0"
                                  v-if="showData2(itemDrug2, index)"
                                >
                                  <div v-if="drug.drug.length !== 0">
                                    <v-row class="ma-0 pa-0">
                                      <v-col
                                        class="d-flex pa-1 align-center"
                                        style="border-bottom: 1px #313b41 solid"
                                      >
                                        <span class="w-300 font-18 text-00A99D"
                                          >สั่งยา</span
                                        >
                                      </v-col>
                                    </v-row>
                                    <v-row
                                      class="ma-0 pa-0 mb-3"
                                      style="border-bottom: 1px #313b41 solid"
                                      v-if="drug.drug.length !== 0"
                                    >
                                      <v-col class="pa-1" cols="1">
                                        <span class="w-300 font-18 text-00A99D"
                                          >#</span
                                        >
                                      </v-col>
                                      <v-col class="pa-1" cols="4">
                                        <span class="w-300 font-18 text-00A99D"
                                          >รายการยา</span
                                        >
                                      </v-col>
                                      <v-col
                                        class="pa-1"
                                        cols="2"
                                        align="center"
                                      >
                                        <span class="w-300 font-18 text-00A99D"
                                          >จำนวน</span
                                        >
                                      </v-col>
                                      <v-col
                                        class="pa-1"
                                        cols="2"
                                        align="center"
                                      >
                                        <span class="w-300 font-18 text-00A99D"
                                          >ราคา</span
                                        >
                                      </v-col>
                                      <v-col
                                        class="pa-1"
                                        cols="2"
                                        align="center"
                                      >
                                        <span class="w-300 font-18 text-00A99D"
                                          >ราคารวม
                                        </span>
                                      </v-col>
                                      <v-col
                                        class="pa-1"
                                        cols="1"
                                        align="center"
                                      >
                                        <span class="w-300 font-18 text-00A99D">
                                          สถานะ
                                        </span>
                                      </v-col>
                                    </v-row>

                                    <v-row
                                      class="ma-0 pa-0"
                                      v-for="(item, index) in drug.drug"
                                      :key="index"
                                    >
                                      <v-col
                                        class="pa-1"
                                        cols="1"
                                        align-self="center"
                                      >
                                        <span
                                          class="w-300 font-18 text-313B41"
                                          >{{ index + 1 }}</span
                                        >
                                      </v-col>
                                      <v-col class="pa-1" cols="4">
                                        <span class="w-300 font-18 text-313B41">
                                          <v-text-field
                                            class="text-field"
                                            :value="item.name_drug"
                                            outlined
                                            dense
                                            small
                                            hide-details
                                            readonly
                                          ></v-text-field>
                                        </span>
                                      </v-col>
                                      <v-col
                                        class="pa-1"
                                        cols="2"
                                        align="center"
                                      >
                                        <span class="w-300 font-18 text-313B41">
                                          <v-text-field
                                            class="text-field"
                                            type="number"
                                            v-model="item.count"
                                            outlined
                                            dense
                                            small
                                            hide-details
                                            :min="0"
                                            readonly
                                          ></v-text-field>
                                        </span>
                                      </v-col>
                                      <v-col
                                        class="pa-1 text-center"
                                        cols="2"
                                        align="center"
                                      >
                                        <span class="w-300 font-18 text-313B41">
                                          <v-text-field
                                            class="text-field"
                                            :value="item.price"
                                            outlined
                                            dense
                                            small
                                            readonly
                                            hide-details
                                          ></v-text-field>
                                        </span>
                                      </v-col>
                                      <v-col
                                        class="pa-1"
                                        cols="2"
                                        align="center"
                                        text-align="center"
                                      >
                                        <span class="w-300 font-18 text-313B41">
                                          <v-text-field
                                            class="text-field"
                                            :value="item.total"
                                            outlined
                                            dense
                                            small
                                            readonly
                                            hide-details
                                          ></v-text-field>
                                        </span>
                                      </v-col>
                                      <v-col
                                        v-if="item.status !== false"
                                        class="pa-1"
                                        cols="1"
                                        align="center"
                                        text-align="center"
                                      >
                                        <v-chip
                                          class="ma-2"
                                          color="green"
                                          text-color="white"
                                        >
                                          <v-icon size="18px" left>
                                            mdi-checkbox-marked-circle-outline
                                          </v-icon>
                                          <span class="font-10"> จ่ายยา</span>
                                         
                                        </v-chip>
                                      </v-col>
                                      <v-col
                                        v-else
                                        class="pa-1"
                                        cols="1"
                                        align="center"
                                        text-align="center"
                                      >
                                        <v-chip
                                          class="ma-2"
                                          color="red"
                                          text-color="white"
                                        
                                          ><v-icon size="18px" left>
                                            mdi-close-circle-outline
                                          </v-icon>
                                          <span class="font-10 mr-4 ma-0"> ไม่จ่ายยา</span>
                                        </v-chip>
                                      </v-col>

                                      <v-col
                                        class="pa-1"
                                        cols="1"
                                        align-self="center"
                                      ></v-col>
                                      <v-col
                                        class="pa-1"
                                        cols="10"
                                        align-self="center"
                                      >
                                        <v-row class="usageAndAdvice">
                                          <v-col
                                            class="pa-1"
                                            cols="12"
                                            align-self="center"
                                            style="
                                              white-space: wrap;
                                              text-overflow: ellipsis;
                                            "
                                          >
                                            <span
                                              class="w-700 font-14 text-313B41"
                                            >
                                              ข้อมูลการใช้ยา :
                                            </span>
                                            <span
                                              class="w-300 font-14 text-313B41"
                                            >
                                              {{ item.usage || "-" }}
                                            </span>
                                          </v-col>
                                          <v-col
                                            class="pa-1"
                                            cols="12"
                                            align-self="center"
                                            style="text-align: center"
                                            v-if="item.advice"
                                          >
                                            <span
                                              class="w-700 font-12 text-EB5757"
                                            >
                                              ***
                                              {{ item.advice }}
                                              ***
                                            </span>
                                          </v-col>
                                        </v-row>
                                      </v-col>
                                    </v-row>
                                    <v-col
                                      cols="12"
                                      class="d-flex justify-center"
                                    >
                                      <span
                                        >สรุปยอดรายการยา
                                        {{ sum2(index) }} บาท</span
                                      >
                                    </v-col>
                                  </div>
                                </v-col>
                              </div>

                              <v-row
                                class="pa-0 ma-0"
                                v-if="
                                  showCurrent2 == null ||
                                  showCurrent2.drug_list.length == 0
                                "
                              >
                                <v-col
                                  cols="12"
                                  class="noitems d-flex justify-center align-center text-center"
                                >
                                  <span class="font-18 w-700 text-00A99D"
                                    >ไม่มีรายการยา</span
                                  >
                                </v-col>
                              </v-row>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row v-else class="ma-5 mt-8">
                  <v-col
                    cols="12"
                    class="bg-white pl-0 pr-0 mb-5"
                    style="height: 40vh"
                    align="center"
                  >
                    <span class="font-18 w-700 text-00A99D"
                      >ไม่พบประวัติการจ่ายยา</span
                    >
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>
      </v-card-text>
      <CancelForm ref="cancelForm" />
    </v-card>
    <RegisterDialog ref="registerDialog" />
    <PDFDialog ref="PDF_Dialog" @loading="loading_PDF_Dialog" />
    <FormDisabledPerson ref="formDisabledPerson" />
    <FormElderlyPerson ref="formElderlyPerson" />
  </v-dialog>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
// import HistoryCalling from "./HistoryCalling.vue";
import { Pagination } from "@/components/pagination";
import functioncryto from "@/services/encrypt.js";
import RegisterDialog from "@/views/HomeVisit/RegisterDialog.vue";
import PDFDialog from "@/views/HomeVisit/PDF_Dialog.vue";
import FormDisabledPerson from "@/views/HomeVisit/FormHomeVisit/FormDisabledPerson.vue";
import FormElderlyPerson from "@/views/HomeVisit/FormHomeVisit/FormElderlyPerson.vue";
import CancelForm from "@/views/HomeVisit/CancelForm.vue";
import Doc from "@/assets/icon/Doc.vue";

export default {
  components: {
    // HistoryCalling,
    Pagination,
    RegisterDialog,
    PDFDialog,
    FormDisabledPerson,
    FormElderlyPerson,
    CancelForm,
    Doc,
  },
  data() {
    return {
      tab: "",
      dialog: false,
      selectedItem: "",
      selectedItem2: "",
      headers: [
        {
          text: "ประเภทการโทร",
          value: "no",
          sortable: false,
          align: "center",
          width: "15%",
        },
        {
          text: "ผู้สนทนาปลายทาง",
          align: "left",
          sortable: false,
          value: "name",
          width: "30%",
        },
        {
          text: "ผู้ป่วยที่ทำการรักษา",
          align: "left",
          sortable: false,
          value: "patient",
          width: "30%",
        },
        {
          text: "วันที่โทร",
          align: "left",
          sortable: false,
          value: "createdAt",
          width: "15%",
        },
      ],
      headersHomeVisit: [
        {
          text: "นัดหมายครั้งที่",
          align: "center",
          value: "appointment_no",
          width: "10%",
        },
        {
          text: "ชื่อผู้ใช้บริการ",
          align: "start",
          value: "name",
          width: "220px",
        },
        {
          text: "วันเวลาที่นัดหมาย",
          value: "slot_date",
          width: "15%",
        },
        {
          text: "ทีมแพทย์",
          value: "doctor_name",
          width: "160px",
        },
        {
          text: "สถานะ",
          value: "status",
          width: "110px",
        },
        {
          text: "",
          value: "data-table-expand",
        },
      ],
      expanded: [],
      itemHistoryHomeVisit: [],
      itemHistoryCalling: [],
      itemHistory: [],
      itemDrug: [],
      showCurrent: null,
      selectPatient: {},
      total: 0,
      page: 1,
      totalCalling: 0,
      pageCalling: 1,
      totalHomeVisit: 0,
      pageHomeVisit: 1,
      limitHomeVisit: 5,
      loadingTable: false,
      select_status: "",
      status_list: [
        { id: 0, text: "สถานะทั้งหมด", value: "" },
        { id: 1, text: "รอเยี่ยมบ้าน", value: "1" },
        { id: 2, text: "กำลังดำเนินการ", value: "2" },
        { id: 3, text: "เสร็จสิ้น", value: "3" },
        { id: 4, text: "ยกเลิก", value: "4" },
      ],
      day_menu: false,
      select_date: [],
      dateText: "",
      start_date: "",
      end_date: "",
      loading_PDF: [],
      totalPrescpt: 0,
      pagePrescpt: 1,
      itemPrescription: [],
      showCurrent2: null,
    };
  },
  computed: {
    ...mapGetters({
      organization_vuex: "organizationGetter" || [],
    }),
    almost_mobile() {
      if (this.$vuetify.breakpoint.width < 450) {
        return true;
      } else {
        return false;
      }
    },
    display_vuetify() {
      return this.$vuetify.breakpoint.name;
    },
  },
  methods: {
    async open(item) {
      this.selectPatient = item;
      await this.getHistory();
      await this.getHistoryCalling();
      await this.getHistoryHomeVisit();
      await this.getPrescription();
      this.dialog = true;
    },
    changeSelect(e) {
      if (e) this.showCurrent = this.itemHistory.find((obj) => obj._id === e);
      else this.showCurrent = null;
      // console.log(this.showCurrent);
    },
    async getHistory() {
      try {
        const params = new URLSearchParams();
        params.append("page", this.page || 1);
        params.append("limit", 5);
        params.append("biz_id", sessionStorage.biz_id);
        if (this.selectPatient.one_id && this.selectPatient.one_id !== "") {
          params.append("search", this.selectPatient.one_id);
        } else if (this.selectPatient.userqr_id) {
          params.append("search", this.selectPatient.userqr_id);
        } else {
          params.append(
            "search",
            `${this.selectPatient.first_name_th} ${this.selectPatient.last_name_th}`
          );
        }

        const { data: { data, result } = {} } = await this.axios.get(
          `${process.env.VUE_APP_BACKEND_URL}/v1/diagnostic-histories/patient?${params}`
        );

        if (result == "success") {
          if (data[0]) {
            this.itemDrug = [];
            const { data: searchData, metadata } = data[0];
            const { total } = metadata[0];
            this.total = total;
            this.itemHistory = searchData;
            searchData.forEach((element) => {
              this.itemDrug.push({ id: element._id, drug: element.drug_list });
            });
          }
        }
      } catch (error) {
        console.error();
      }
    },
    displayDate(date) {
      if (!date) return "-";
      return moment(date)
        .locale("th")
        .add(543, "years")
        .format("D MMMM YYYY HH:mm น.");
    },
    displayBirthDate(date) {
      if (!date) return "-";
      return moment(date).locale("th").add(543, "years").format("DD MMMM YYYY");
    },
    changePage(e) {
      this.page = e;
      this.getHistory();
    },
    changePageCalling(e) {
      // console.log(e, this.pageCalling);
      this.pageCalling = e;
      this.getHistoryCalling();
    },
    changePageHomeVisit(e) {
      this.pageHomeVisit = e;
      this.getHistoryHomeVisit();
    },
    showData(item, index) {
      if (item[index].id == this.selectedItem) {
        return true;
      }
    },
    close() {
      this.dialog = false;
      this.itemHistoryHomeVisit = [];
      this.itemHistoryCalling = [];
      this.itemHistory = [];
      this.itemPrescription = [];
      this.tab = "tab-1";
      this.select_status = "";
    },
    async getHistoryCalling() {
      try {
        const params = new URLSearchParams();
        params.append("page", this.pageCalling || 1);
        params.append("limit", 5);
        params.append(
          "one_id",
          this.selectPatient.one_id
            ? this.selectPatient.one_id
            : this.selectPatient.userqr_id
        );
        params.append("biz_id", sessionStorage.biz_id);

        const { data: { data, result } = {} } = await this.axios.get(
          `${process.env.VUE_APP_BACKEND_URL}/v1/conferences/history-patient?${params}`
        );

        if (result == "success") {
          if (data[0]) {
            const { data: searchData, metadata } = data[0];
            const { total } = metadata[0];
            this.totalCalling = total;
            this.itemHistoryCalling = searchData;
          }
        }
      } catch (error) {
        console.error();
      }
    },
    async getPrescription() {
      try {
        const params = new URLSearchParams();
        params.append("page", this.pagePrescpt || 1);
        params.append("limit", 10);
        if (
          this.selectPatient.one_id !== "" &&
          this.selectPatient.one_id !== null
        ) {
          params.append("patient_id", this.selectPatient.one_id);
        } else {
          params.append("patient_cid", this.selectPatient.cid);
        }
        params.append("biz_id", sessionStorage.biz_id);
        params.append("status", "confirm");

        const { data: { data, result } = {} } = await this.axios.get(
          `${process.env.VUE_APP_BACKEND_URL}/v1/prescription?${params}`
        );

        if (result == "success") {
          if (data[0]) {
            this.itemDrug2 = [];
            const { data: searchData, metadata } = data[0];
            const { total } = metadata[0];
            this.totalPrescpt = total;
            this.itemPrescription = searchData;
            searchData.forEach((element) => {
              this.itemDrug2.push({ id: element._id, drug: element.drug_list });
            });
            // console.log("itemPrescription",this.itemPrescription);
          }
        }
      } catch (error) {
        console.error();
      }
    },
    changePagePrescpt(e) {
      this.pagePrescpt = e;
      this.getPrescription();
    },
    changeSelect2(e) {
      if (e)
        this.showCurrent2 = this.itemPrescription.find((obj) => obj._id === e);
      else this.showCurrent2 = null;
    },
    showData2(item, index) {
      if (item[index].id == this.selectedItem2) {
        return true;
      }
    },
    sum2(index) {
      if (this.itemDrug2[index].drug) {
        return this.itemDrug2[index].drug
          .filter((drug) => drug.status === true)
          .reduce((total, drug) => total + drug.total, 0);
      }

      return "";
    },
    async getHistoryHomeVisit() {
      try {
        this.expanded = [];
        this.loadingTable = true;
        const params = new URLSearchParams();
        params.append("page", this.pageHomeVisit);
        params.append("limit", this.limitHomeVisit);
        params.append("userqr_id", this.selectPatient.userqr_id);
        params.append("biz_id", sessionStorage.biz_id);
        params.append("start_date", this.start_date || "");
        params.append("end_date", this.end_date || "");
        params.append("status", this.select_status || "");

        await this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/v1/histoy_appointment_home_visit?${params}`
          )
          .then((res) => {
            let data = res.data.data[0];
            this.itemHistoryHomeVisit = data.data;
            this.totalHomeVisit = data.metadata[0].total;
            this.loadingTable = false;
          });
      } catch (error) {
        console.error();
        this.loadingTable = false;
      }
    },
    selectStatus() {
      this.pageHomeVisit = 1;
      this.getHistoryHomeVisit();
    },
    selectDate() {
      if (this.select_date.length >= 2) {
        if (this.select_date[0] < this.select_date[1]) {
          this.start_date = this.select_date[0];
          this.end_date = this.select_date[1];
        } else {
          this.start_date = this.select_date[1];
          this.end_date = this.select_date[0];
        }
        this.dateText = `${moment(this.start_date)
          .add(543, "year")
          .locale("th")
          .format("D MMM YY")} - ${moment(this.end_date)
          .add(543, "year")
          .locale("th")
          .format("D MMM YY")}`;
      } else if (this.select_date.length >= 1) {
        this.start_date = this.select_date[0];
        this.end_date = "";
        this.dateText = moment(this.start_date)
          .add(543, "year")
          .locale("th")
          .format("D MMM YY");
      } else {
        this.start_date = "";
        this.end_date = "";
        this.dateText = "";
      }
      this.pageHomeVisit = 1;
      this.getHistoryHomeVisit();
      this.day_menu = false;
    },
    clearDate() {
      this.dateText = "";
      this.select_date = [];
      this.start_date = "";
      this.end_date = "";
      this.pageHomeVisit = 1;
      this.getHistoryHomeVisit();
      this.day_menu = false;
    },
    check_form(item, value, text) {
      // console.log("item", item);
      // console.log("value", value);
      // console.log("text", text);
      if (value.form_name == "แบบฟอร์มเยี่ยมบ้านคลินิกอบอุ่น") {
        this.$refs.registerDialog.openDialog(item, value, text);
      } else if (value.form_name == "แบบฟอร์มเยี่ยมบ้านผู้พิการ") {
        this.$refs.formDisabledPerson.openDialog(item, value, text);
      } else if (value.form_name == "แบบฟอร์มเยี่ยมบ้านผู้สูงอายุ") {
        this.$refs.formElderlyPerson.openDialog(item, value, text);
      } else {
        this.$refs.registerDialog.openDialog(item, value, text);
      }
    },
    PDF_Dialog(value, index) {
      // this.itemHistoryHomeVisit[index].loading_PDF = true;
      this.loading_PDF[index] = true;
      this.$refs.PDF_Dialog.openDialog(value, index);
    },
    loading_PDF_Dialog() {
      // this.itemHistoryHomeVisit[index].loading_PDF = false;
      // this.loading_PDF[index] = false;
      this.loading_PDF = [];
    },
    setLoadingPDF(length) {
      this.loading_PDF = [];
      for (let index = 0; index < length; index++) {
        this.loading_PDF.push(false);
      }
      console.log("🚀 ~ this.loading_PDF:", this.loading_PDF);
    },
    cancelForm(item, value, text) {
      this.$refs.cancelForm.openDialog(item, value, text);
    },
    displayCalling(calling) {
      if (!calling.staffs) return "-";
      return calling.staffs.fullname;
    },
    checkCalling(calling) {
      if (!calling) return "-";

      const { receiver_oneid = {} } = calling;

      if (sessionStorage.account_id == receiver_oneid)
        return { img: "receiver.svg", text: "รับสาย" };
      return { img: "calling.svg", text: "โทรออก" };
    },
    displayName(item) {
      if (item.patient) {
        const {
          patient: { account_title_th, first_name_th, last_name_th } = {},
        } = item;

        return `${account_title_th} ${first_name_th} ${last_name_th}`;
      }
      return "-";
    },
    displayCID(cid) {
      if (cid) {
        const maskedDigits = "X".repeat(6);
        const visibleDigits = functioncryto.decrypt(cid).substring(6);
        return maskedDigits + visibleDigits;
      } else return "-";
    },
    ageCalcilar(birth) {
      const today = new Date();
      const birthDate = new Date(birth);
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();

      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }

      return age || "-";
    },
    genderPerson(account_title_th) {
      if (account_title_th) {
        if (["เด็กชาย", "นาย"].includes(account_title_th)) return "ชาย";
        if (["เด็กหญิง", "นางสาว", "นาง"].includes(account_title_th))
          return "หญิง";
      } else {
        return "-";
      }
    },
    showMobile(mobile) {
      if (mobile) {
        if (mobile.length === 10) {
          return (
            mobile.slice(0, 3) +
            "-" +
            mobile.slice(3, 6) +
            "-" +
            mobile.slice(6, 10)
          );
        } else if (mobile.length === 9) {
          return (
            mobile.slice(0, 3) +
            "-" +
            mobile.slice(3, 6) +
            "-" +
            mobile.slice(6, 9)
          );
        } else {
          return mobile;
        }
      } else {
        return "-";
      }
    },
    sum(index) {
      if (this.itemDrug[index].drug) {
        return this.itemDrug[index].drug.reduce(
          (total, drug) => total + drug.total,
          0
        );
      }

      return "";
    },
    formatDate(data) {
      if (!data) {
        return null;
      }

      let datetime = new Date(
        new Date(data) - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, -1)
        .substr(0, 10);
      var [year, month, day] = datetime.split("-");
      return `${day}/${month}/${parseInt(year) + 543}`;
    },
  },
};
</script>

<style scoped>
.v-tab--active {
  background: #00a99d;
  color: white;
}
.table-viewdoc th {
  background: #ceefed !important;
  color: #00a99d !important;
}
.card_pr {
  padding-right: 12px;
}
.card-small {
  background: #ceefed;
  border-radius: 20px 5px;
  box-shadow: none !important;
}
.usageAndAdvice {
  border: 1px solid #bdbdbd;
  border-radius: 4px;
  margin: 0px;
}
.noitems {
  height: 50vh;
}

::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}

::v-deep
  .set-card.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 20px 5px !important;
  box-shadow: none;
}

::v-deep .v-list-item-group .v-list-item--active {
  background: #4ba69d;
  color: #fff;
}

.custom-text {
  font-size: 18px;
  color: black;
}

::v-deep .v-data-table-header {
  background: #ceefed;
}
::v-deep .v-data-table > .v-data-table__wrapper > table > tbody {
  display: table-row-group;
  vertical-align: middle;
  border-color: inherit;
}
::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  color: #00a99d;
  font-weight: 700;
  font-size: 14px !important;
}
::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 14px !important;
  height: 48px;
}

::v-deep
  .v-data-table
  > .v-data-table__wrapper
  .v-data-table__mobile-table-row {
  display: block !important;
  background-color: white;
}
::v-deep .v-data-table > .v-data-table__wrapper > table {
  border-spacing: 0 15px;
  background: #fff;
  /* border-collapse: separate; */
  /* border-bottom: none; */
}
::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr {
  background: #ebf7f7;
}
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  border-bottom: none;
}
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th {
  border-bottom: none;
}
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > td:not(.v-data-table__mobile-row),
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > th:not(.v-data-table__mobile-row) {
  border-bottom: none;
}
.theme--light.v-data-table
  .v-data-table-header
  th.sortable
  .v-data-table-header__icon {
  display: none;
}
::v-deep .v-data-table-header__icon {
  display: none;
}
::v-deep
  .v-data-table
  > .v-data-table__wrapper
  .v-data-table__mobile-table-row {
  display: block !important;
  background-color: white;
}
::v-deep .v-data-table-header.v-data-table-header-mobile {
  display: none;
}
::v-deep .v-data-table-header__icon {
  display: none;
}
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(
    .v-data-table__empty-wrapper
  ) {
  background: #ceefed !important;
}

.set-active-color {
  background-color: #00a99d !important;
}

.card-form_list:hover {
  box-shadow: 5px 5px #ceefed !important;
}

.screenshot-img {
  width: 100%;
  max-width: 450px;
  height: 250px;
  border: 2px solid #f1f1f1;
}
</style>
